import { render, staticRenderFns } from "./product-player.vue?vue&type=template&id=3e68b556&scoped=true&"
import script from "./product-player.vue?vue&type=script&lang=js&"
export * from "./product-player.vue?vue&type=script&lang=js&"
import style0 from "./product-player.vue?vue&type=style&index=0&id=3e68b556&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e68b556",
  null
  
)

export default component.exports